'use strict';
class DeveloperNotificationsController {

    constructor(SSUtilService, SSHttpService, SSConfigService, SSAlertService, SSUserService) {
        const self = this;

        self.SSUtilService = SSUtilService;
        self.SSHttpService = SSHttpService;
        self.SSConfigService = SSConfigService;
        self.SSAlertService = SSAlertService;
        self.SSUserService = SSUserService;

        self.has_access = false;
        if (self.SSUserService.isDeveloper()) {
            self.init();
            self.has_access = true;
        }
    }

    init() {
        const self = this;

        self.filters = {
            offset: 0,
            limit: 10
        };

        self.load();
    }

    load() {
        const self = this;

        self.notifications = [];

        let url = 'notifications';

        loading(true);
        self.SSHttpService.getAPIRequest(url, self.filters).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                return;
            }

            self.notifications = response.data.notifications;
        });
    }

    changeGroup(group) {
        const self = this;

        self.filters.group = group;
        self.load();
    }

    changeType(type) {
        const self = this;

        self.filters.type = type;
        self.load();
    }

    nextPage() {
        const self = this;

        if (!self.notifications || self.notifications.length < self.filters.limit) return;

        self.filters.offset = self.filters.offset + self.notifications.length;

        self.load();
    }

    previousPage() {
        const self = this;

        if (!self.filters.offset) return;

        self.filters.offset = self.filters.offset - self.filters.limit;
        self.filters.offset = self.filters.offset < 0 ? 0 : self.filters.offset;

        self.load();
    }

    markAsRead(notification, status) {
        const self = this;

        let url = 'notifications/mark-as-read';
        let params = {
            notification_ids: notification.id,
            status: status
        };

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                if (response.code == 401) {
                    self.SSAlertService.danger("Oops!", "Your session has expired. Please re-login to continue.");
                } else {
                    self.SSAlertService.danger("Oops!", "Something went wrong. Please contact support.");
                }
                return;
            }
            self.SSAlertService.clear();

            notification.status = status;
        });
    }

}

DeveloperNotificationsController.$inject = ['SSUtilService', 'SSHttpService', 'SSConfigService', 'SSAlertService', 'SSUserService'];
app.controller('DeveloperNotificationsController', DeveloperNotificationsController);